export default __webpack_public_path__ + "static/katz-logo-697f2ba454048cdf5c0a628cbe85cbf2.png";